import { useRouter } from "vue-router";
import { useStore } from "vuex";

import { ACCOUNT_TYPE } from "@/constants";

export const useRedirectBasedOnRole = () => {
  const store = useStore();
  const router = useRouter();

  return () => {
    const type = store.state.authentication.selectedAccount?.type_name;

    if (type === ACCOUNT_TYPE.SYSTEM) {
      return router.push("/system");
    }

    if (type === ACCOUNT_TYPE.MSP) {
      return router.push("/msp");
    }

    if (type === ACCOUNT_TYPE.CUSTOMER) {
      return router.push("/customer");
    }

    return router.push("/auth");
  };
};
